import {authRequest} from "@/api";

const bashUrl = '/'

/**
 * 登录
 * @param data
 */
export const login = (data) => {
    return authRequest({
        url: `${bashUrl}login`,
        method: 'post',
        data
    })
}
/**
 * 刷新token
 */
export const refreshToken = () => {
    return authRequest({
        url: `${bashUrl}refresh-token`,
        method: 'post'
    })
}


/**
 * 更新用户详情
 */
export const updateUserInfo = () => {
    return authRequest({
        url: `${bashUrl}update-user-info`,
        method: 'get'
    })
}

/**
 * 登录退出
 * @returns {*}
 */
export const loginOut = () => {
    return authRequest({
        url: `${bashUrl}login-out`,
        method: 'post',
        // 退出接口失败时不触发刷新 token 弹窗，前端仍然会清理本地登录状态。
        skipAuthRefresh: true
    })
}
